module.exports = __webpack_public_path__ + "img/2b4f69068900480d9b23bdc7973ee2fe-1440.6cbb73ef.png";